<!-- 策略配置 -->
<template>
  <div class="policyPage">
    <el-button type="primary" @click="policyDialog" icon="el-icon-plus" style="margin-bottom:10px">添加策略</el-button>
    <cs-table :tableCols="tableCols" :tableData="policyData" :paginationOption="pageOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler">
      <template slot-scope="scope" slot="status">
        {{scope.row.status==0?'已停用':'启用中'}}
      </template>
      <template slot-scope="scope" slot="control">
        <span @click="toEnableHandle(scope.row)">
          <el-tooltip v-if="scope.row.status==0" class="item" effect="dark" content="启用" placement="top">
            <i  class="el-icon-circle-check el-icon-size"></i>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark" content="禁用" placement="top">
            <i  class="el-icon-discover el-icon-size"></i>
          </el-tooltip>
        </span>
        <span @click="deleteHandle(scope.row)" >
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <i class="el-icon-delete el-icon-size"></i>
          </el-tooltip>
        </span>
      </template>
    </cs-table>
    <el-dialog title="添加策略" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="policyForm" :model="policyForm" label-width="125px" :rules="rules">
        <el-form-item label="转码配置:" prop="tencentId">
          <el-select v-model="policyForm.tencentId" style="width:38%" clearable placeholder="请选择转码模板">
            <el-option v-for="item in transcodOptions" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面图截取时间:" prop="startTime">
          <el-input-number v-model="time.startTime" controls-position="right" :min="0" :step="1" ></el-input-number>
          ：
          <el-input-number v-model="time.endTime" controls-position="right" :min="0" :max="59" :step="1" ></el-input-number>
        </el-form-item>
        <el-form-item label="推送站点:" prop="pushSite" v-if="false">
          <el-select v-model="policyForm.pushSite" style="width:38%" clearable placeholder="请选择推送站点">
            <el-option v-for="item in pushSiteOptions" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="立即启用:" prop="status">
          <el-switch  v-model="status" active-text="启用" inactive-text="禁用" active-color="#1890FF" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">返 回</el-button>
        <el-button type="primary" @click="submitHandle('policyForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { fetchStrategySetting, fetchStrategySettingPut, fetchStrategySettingRm, fetchTencentTemplate, fetchGetSiteAppsBySystemIds, fetchStrategySettingAdd } from '@/resource/api/index'
export default {
  name: 'PolicyPage',
  data () {
    return {
      dialogVisible: false,
      tableCols: [ // 策略配置 table col
        { prop: 'id', label: '策略ID' },
        { prop: 'tencentName', label: '转码配置' },
        { prop: 'extTime', label: '封面图截取时间' },
        // { prop: 'pushSite', label: '推送站点名称' },
        { prop: 'status', label: '状态', type: 'slot' },
        { prop: 'control', label: '操作', type: 'slot' }
      ],
      searchParams: {
        limit: this.$store.state.pageLimit,
        offset: 1,
        platform: this.$store.state.router.cpcode
      },
      pageOption: {},
      policyData: [], // 策略配置TABLE DATA
      status: true,
      policyForm: { // 策略配置表单
        tencentId: '', // 模版id
        tencentName: '', // 转码配置
        pushSite: -1, // 推送站点
        status: true,
        extTime: '',
        createby: '',
        platform: this.$store.state.router.cpcode
      },
      time: { // 封面图截取时间
        startTime: '0',
        endTime: '0'
      },
      transcodOptions: [],
      pushSiteOptions: [],
      rules: { // 表单验证
        tencentId: [
          { required: true, message: '请选择转码模版', trigger: 'blur' }
        ],
        pushSite: [
          { required: true, message: '请选择推送站点', trigger: 'blur' }
        ],
        extTime: [
          { required: true, message: '请选择封面图截取时间', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.pageOption['page-size'] = this.$store.state.pageLimit
    this.policyForm.createBy = this.$store.state.router.createBySuffix
    this.fetchPolicy()
  },
  methods: {
    // 添加策略DIALOG
    policyDialog () {
      this.dialogVisible = true
      this.fetchTencentTemplate()
      this.fetchGetSiteAppsBySystemIds()
      this.time = {
        startTime: '',
        endTime: '1'
      }
      this.$nextTick(() => { // 等待dom同步后打开模态框
        this.$refs.policyForm.resetFields()
      })
    },
    // 提交表单
    submitHandle (formName) {
      this.policyForm.status = this.status ? 1 : 0
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.policyForm.tencentId) {
            this.transcodOptions.forEach(item => {
              if (item.value == this.policyForm.tencentId) {
                this.policyForm.tencentName = item.label
              }
            })
          }
          // 时间格式转换
          const startTime = this.time.startTime > 9 ? this.time.startTime : '0' + this.time.startTime
          const endTime = this.time.endTime > 9 ? this.time.endTime : '0' + this.time.endTime
          this.policyForm.extTime = startTime + ':' + endTime

          this.$confirm('策略配置只能启用一项，您是要启用该配置并停用其它配置吗', '温馨提示', {
            confirmButtonText: '启用',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            fetchStrategySettingAdd(that.policyForm).then((res) => {
              if (res.code == '1') {
                that.dialogVisible = false
                this.fetchPolicy()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消启用'
            })
          })
        }
      })
    },
    // 是否启用
    toEnableHandle (row) {
      var lock = '启用成功'
      if (row.status == 0) {
        this.$confirm('策略配置只能启用一项，您是要启用该配置并停用其它配置吗', '温馨提示', {
          confirmButtonText: '启用',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          row.createBy = this.$store.state.router.createBySuffix
          row.status = 1
          this.fetchStrategySettingPut(row, lock)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用'
          })
        })
      } else {
        lock = '禁用成功'
        row.status = 0
        this.fetchStrategySettingPut(row, lock)
      }
    },
    fetchStrategySettingPut (row, lock) {
      delete row.createTime
      delete row.updateTime
      delete row.pushSite
      row.platform = this.$store.state.router.cpcode
      fetchStrategySettingPut(row).then((res) => {
        if (res.code == '1') {
          this.$message({
            type: 'success',
            message: `${lock}!`
          })
          this.dialogVisible = false
          this.fetchPolicy()
        }
      })
    },
    deleteHandle (row) {
      const that = this
      const data = { id: row.id, updateBy: this.$store.state.router.updateBySuffix, platform: this.$store.state.router.cpcode }
      this.$confirm('此操作将删除该数据, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetchStrategySettingRm(data).then((res) => {
          if (res.code == '1') {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.fetchPolicy()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 策略配置 DATA
    fetchPolicy () {
      fetchStrategySetting(this.searchParams).then((res) => {
        if (res.code == '1') {
          this.policyData = res.results
          this.pageOption = {
            ...this.pageOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    // 获取模版数据
    fetchTencentTemplate () {
      const that = this
      that.transcodOptions = []
      fetchTencentTemplate().then((res) => {
        if (res.code == '1') {
          const arr = res.results
          arr.forEach(function (item) {
            that.transcodOptions.push({ label: item.Name, value: item.Definition })
          })
        }
      })
    },
    // 获取站点
    fetchGetSiteAppsBySystemIds () {
      const that = this
      const data = {
        type: 'normal'
      }
      that.pushSiteOptions = []
      fetchGetSiteAppsBySystemIds(data).then((res) => {
        if (res.code == '1') {
          const pushArr = res.results
          pushArr.forEach(function (item) {
            that.pushSiteOptions.push({ label: item.name, value: item.id })
          })
        }
      })
    },
    sizeChangeHandler (val) {
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.fetchPolicy()
    },
    currentPageHandler (val) {
      this.searchParams.offset = val
      this.fetchPolicy()
    }
  }
}
</script>
<style lang="less" scoped>
  .el-icon-size {
    font-size: 16px;
    padding-left: 15px;
    cursor: pointer;
  }
</style>
